// CANONICAL COPY (GH #7115). src/constants/obligations/obl-poi-tamper-protection.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-poi-tamper-protection',
  title: 'Verify payment terminal (POI) tamper protection',
  description:
    'Confirm that point-of-interaction (POI) devices capturing payment card data through direct physical interaction are protected against tampering and unauthorized substitution (PCI DSS Req 9.5). An up-to-date list of such devices shall be maintained, devices shall be periodically inspected for tampering or substitution, and personnel shall be trained to detect and report suspicious behaviour around terminals. Review the POI device list, the inspection procedure and recent inspection records.',
  category: 'assets',
  scfIds: ['SCF-PHY-015'],
  cadence: { frequency: '6m', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'POI device list / tamper-inspection procedure is published',
    },
    { type: 'document-within-sla', description: 'Inspection procedure review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
